import { ReactElement } from 'react';
import {
  ListItemProps as ListItemChakraProps,
  ListItem as ListItemChakra,
  Icon as IconChakra,
  Flex,
  Box,
} from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';

import { IconType, PropsWithChildren } from 'lib/@types';

type VariantsAvailable = 'notClosable' | 'closable';

export interface ListItemProps extends ListItemChakraProps {
  icon?: IconType;
  variant?: VariantsAvailable;
  onClose?: () => void;
}

export const ListItem = ({
  children,
  icon,
  variant = 'notClosable',
  onClose,
  ...props
}: PropsWithChildren<ListItemProps>): ReactElement => (
  <ListItemChakra my='4' color='text.100' lineHeight={5} {...props}>
    <Flex
      alignItems={['flex-start', 'flex-start', 'center', 'center']}
      justifyContent='space-between'
    >
      <Box>
        <Flex>
          {icon && (
            <IconChakra
              as={icon}
              w={5}
              h={5}
              color='primary.500'
              mr={[2, 2, 4, 4]}
              data-testid='left-icon'
            />
          )}
          {children}
        </Flex>
      </Box>
      {variant === 'closable' && (
        <IconChakra
          as={MdClose}
          w={5}
          h={5}
          color='black.400'
          onClick={onClose}
          cursor='pointer'
          data-testid='close-icon'
          _hover={{
            color: 'secondary.100',
            transition: '0.2s',
          }}
        />
      )}
    </Flex>
  </ListItemChakra>
);
